import { useEffect } from 'react';

import { L3_PATHS } from 'Deer/constants/routes';
import { useRouteToMyTeamLevels } from 'Deer/hooks/useRouteToL3';
import { matchPath, useHistory, useLocation } from 'react-router-dom';
import { useOneOnOneInstanceDetailsFromMasterIdQuery } from 'screens/oneOnOneRabbit/InstancePage/hooks/dataHooks';
import { getOneOnOneInstancePagePath } from 'screens/oneOnOneRabbit/helpers';

interface IUseOneOnOnePageParams {
  masterId: string;
  instanceId: string;
}

const useOneOnOnePageParams = () => {
  const { teamType } = useRouteToMyTeamLevels();
  const location = useLocation();
  let path = L3_PATHS['my-data'].oneOnOne.masterPage;

  if (teamType === 'directReports') {
    path = L3_PATHS.team.directReports.oneOnOne.masterPage;
  } else if (teamType === 'allReports') {
    path = L3_PATHS.team.allReports.oneOnOne.masterPage;
  }

  const { params } =
    matchPath<IUseOneOnOnePageParams>(location.pathname, {
      path,
      exact: true,
    }) ?? {};
  const { masterId, instanceId } = params ?? {};

  return {
    masterId,
    instanceId,
  };
};

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  cohort: any;
}

const OneOnOneMasterPage = ({ cohort }: Props) => {
  const { masterId } = useOneOnOnePageParams();

  const history = useHistory();

  const {
    data: latestInstanceData,
    isLoading: isLoadingLatestInstance,
    isError: isErrorLatestInstance,
  } = useOneOnOneInstanceDetailsFromMasterIdQuery({
    masterId: Number(masterId),
  });

  useEffect(() => {
    if (['audit', 'audit/'].includes(masterId)) {
      history.replace(L3_PATHS['my-data'].oneOnOne.myOneOnOne);
    }
  }, [masterId, history]);

  useEffect(() => {
    if (!isLoadingLatestInstance) {
      if (isErrorLatestInstance) {
        history.replace(L3_PATHS['my-data'].oneOnOne.myOneOnOne);
      } else {
        const oneOnOnePagePath = getOneOnOneInstancePagePath({
          masterId: Number(masterId),
          instanceId: latestInstanceData?.latestInstanceId,
          selectedCohort: cohort?.id,
        });
        history.replace(oneOnOnePagePath);
      }
    }
  }, [latestInstanceData, isLoadingLatestInstance, isErrorLatestInstance, history, masterId, cohort.id]);

  return null;
};

export { OneOnOneMasterPage };
